import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../redux/store';
import { staticUrl } from '../../utils';

/**
 * Beautiful global loading overlay component with modern design
 * Features: custom SVG loading indicator with smooth spin animation
 */
export const LoadingGlobal: React.FC = () => {
  const { isLoading, message } = useSelector(
    (state: RootState) => state.globalLoading
  );

  const [displayLoading, setDisplayLoading] = useState(false);

  useEffect(() => {
    let timer: NodeJS.Timeout;

    if (isLoading) {
      setDisplayLoading(true);
    } else {
      timer = setTimeout(() => {
        setDisplayLoading(false);
      }, 300);
    }

    return () => clearTimeout(timer);
  }, [isLoading]);

  if (!displayLoading) {
    return null;
  }

  return (
    <div className='fixed inset-0 z-50 flex items-center justify-center'>
      {/* Simple backdrop */}
      <div className='absolute inset-0 bg-black/20 backdrop-blur-sm' />

      {/* Loading indicator with SVG */}
      <div className='relative z-10 flex flex-col items-center justify-center space-y-4'>
        {/* SVG spinner with spin animation */}
        <div className='w-12 h-12 animate-spin'>
          <img
            src={staticUrl('/icons/loading-progress-indicator.svg')}
            alt='Loading...'
            className='w-full h-full'
          />
        </div>

        {/* Optional loading text */}
        <p className='text-sm font-medium text-primary-2'>
          {message || 'Loading...'}
        </p>
      </div>
    </div>
  );
};

export default LoadingGlobal;
